import React from 'react';
import { Col } from 'react-bootstrap';
import { formatFieldValue } from 'src/components/Vehicle/Detail/utils';

function LeftField({ label, value }) {
  return (
    <Col xs={6} sm={6} md={6} lg={6} xl={6} className="p-0">
      <div className="div-flex-column">
        <span className="text-sm-outfit secondary-text-grey">{label}</span>
        <span className="text-sm-outfit text-medium-bold">
          {formatFieldValue(value)}
        </span>
      </div>
    </Col>
  );
}

export default function LeftSection({ vehicle }) {
  const transporterNames = vehicle?.transporters
    ?.map((transporter) => transporter.name)
    .join(', ');

  return (
    <div className="horizontal-padding-16 vertical-padding-16">
      <div className="border-bottom padding-bottom-16 div-flex-column rg-15">
        <div className="div-flex-row cg-5">
          <LeftField label="Vehicle Number" value={vehicle?.vehicleNumber} />
          <LeftField label="Brand" value={vehicle?.brand} />
        </div>

        <div className="div-flex-row cg-5">
          <LeftField label="Model" value={vehicle?.model} />
          <LeftField label="Vehicle Type" value={vehicle?.vehicleType?.name} />
        </div>

        <div className="div-flex-row cg-5">
          <LeftField label="Fuel Type" value={vehicle?.fuelType?.name} />
          <LeftField label="Status" value={vehicle?.status?.name} />
        </div>

        <div className="div-flex-row cg-5">
          <LeftField label="Capacity" value={vehicle?.capacity} />
          <LeftField label="Transporter" value={transporterNames} />
        </div>
      </div>
    </div>
  );
}
